import { Button, Checkbox, Col, Input, Popover, Row } from 'antd';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import { ReactComponent as LocationIcon } from 'app/assets/img/location-icon.svg';
import RenderIf from 'app/components/RenderIf';
import useWindowSize from 'app/hooks/useWindowSize';
export const CustomCheckBox = (options: any, value: any, onChange: any) => {
  return (
    <Checkbox.Group onChange={onChange} value={value}>
      <div className="row">
        {options.map((item: any, index: any) => (
          <div key={index} style={{}} className={`col-md-6`}>
            <Checkbox
              style={{
                fontWeight: value.includes(item.value) ? 500 : 400,
                color: '#000000',
                marginBottom: 6,
              }}
              value={item.value}
            >
              {item.label}
            </Checkbox>
          </div>
        ))}
      </div>
    </Checkbox.Group>
  );
};
const ListPark = (props: any) => {
  const { translations, parkId, listParkCustom, onChangePark } = props;
  const [isOpen, setIsOpen] = useState(false);
  const popupContainer = useRef<HTMLDivElement>(null);
  const { device } = useWindowSize();
  const CustomPopoverContent = (
    parkId: any,
    listParkCustom: any,
    onChangePark: any,
  ) => (
    <div className="popover-content" style={{ minWidth: 130, margin: 4 }}>
      {listParkCustom?.length && parkId
        ? CustomCheckBox(listParkCustom, parkId, onChangePark)
        : null}
    </div>
  );
  const handleOpenChange = newOpen => {
    setIsOpen(newOpen);
  };
  const getValueTypeFilter = () => {
    let text = '';
    const arr = listParkCustom.filter(item => parkId.includes(item.value));
    const textGroup = arr.map((i: any) => ` ${i?.label.trim()}`);
    text = textGroup.toString();
    return text;
  };
  const valueTypeFilter = getValueTypeFilter();
  return (
    <ListParkContainer>
      <PopupContainer ref={popupContainer} />
      <StyledPopover
        getPopupContainer={() => popupContainer.current!}
        placement="bottomLeft"
        content={CustomPopoverContent(parkId, listParkCustom, onChangePark)}
        trigger="click"
        overlayInnerStyle={{
          borderRadius: '20px',
          width: `calc(100vw - 70px)`,
          marginTop: '-10px',
        }}
        visible={isOpen}
        onVisibleChange={handleOpenChange}
      >
        <StyledButton
          style={{
            marginBottom: device === 'desktop' ? 20 : 16,
            ...props?.triggerBtnCSS,
          }}
        >
          <div style={{ width: 'calc(100% - 16px)', display: 'inline-block' }}>
            <RenderIf condition={!valueTypeFilter}>
              <LocationIcon
                style={{ marginRight: 8, position: 'relative', top: -1 }}
              />
            </RenderIf>
            <StyledInputFilter
              value={
                (valueTypeFilter || translations?.['b2b.txt.sunworldPark']) ??
                ''
              }
              readOnly
              style={{
                fontWeight: valueTypeFilter ? 400 : 700,
                transition: 'initial',
              }}
            />
          </div>
          <ArrowDownIcon
            style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
          />
        </StyledButton>
      </StyledPopover>
    </ListParkContainer>
  );
};

export default ListPark;

const ListParkContainer = styled.div``;
const StyledButton = styled(Button)<{ isOpen?: boolean }>`
  box-shadow: none !important;
  height: 52px;
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  margin-bottom: 20px;
  transform: ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  &:focus,
  &:active,
  &:hover {
    border: 1px solid #d9d9d9;
    box-shadow: none !important;
  }

  &::after {
    content: none !important;
  }
`;
const StyledPopover = styled(Popover)`
  .ant-popover-inner {
    background-color: lightblue !important;
  }
`;
const StyledInputFilter = styled(Input)`
  border: none;
  padding-left: 0px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ::placeholder {
    color: black;
  }
  .ant-input {
  }
  &:focus,
  &:active,
  &:hover {
    border: none !important;
    box-shadow: none !important;
  }
`;
const PopupContainer = styled.div`
  & > div:first-child {
    z-index: 1;
  }
`;
